import {
  IUnifiedBackgroundCheckDateItem,
  UnifiedBackgroundCheckSource
} from '../../core/interfaces/unified-background-check.interface';
import { CardBadgeKind } from './driver-background-check.view-models';

export const SECTION_AVAILABILITY: { [id: string]: UnifiedBackgroundCheckSource[] } = {
  mvr: ['CheckR'],
  documents: ['CheckR'],
  permits: ['SearchBug'],
};

export const DEACTIVATE_REASON_MAX_LENGTH = 500;

export interface IStatusColor {
  cssClass: string;
  badgeKind: CardBadgeKind;
  optionTextColor: string | null;
}

export const STATUS_COLOR_MAP: { [status: string]: IStatusColor } = {
  CLEAR: { cssClass: 'check-r-clear', badgeKind: 'success', optionTextColor: null },
  CANCELED: { cssClass: 'check-r-canceled', badgeKind: 'danger', optionTextColor: '#dc3545' },
  COMPLETE: { cssClass: 'check-r-complete', badgeKind: 'info', optionTextColor: null },
  CONSIDER: { cssClass: 'check-r-consider', badgeKind: 'warn', optionTextColor: '#92400e' },
  DISPUTE: { cssClass: 'check-r-dispute', badgeKind: 'info', optionTextColor: null },
  PENDING: { cssClass: 'check-r-pending', badgeKind: 'warn', optionTextColor: '#92400e' },
  SUSPENDED: { cssClass: 'check-r-suspended', badgeKind: 'info', optionTextColor: null },
};

export const STATUS_COLOR_FALLBACK: IStatusColor = { cssClass: 'check-r-na', badgeKind: 'info', optionTextColor: null };

export function resolveStatusColor(value: string): IStatusColor {
  if (!value) {
    return STATUS_COLOR_FALLBACK;
  }
  const normalized = value.trim().toUpperCase();
  if (normalized === 'ERROR') {
    return STATUS_COLOR_MAP['CANCELED'];
  }
  if (normalized === 'REVIEW') {
    return STATUS_COLOR_MAP['CONSIDER'];
  }
  return STATUS_COLOR_MAP[normalized] || STATUS_COLOR_FALLBACK;
}

export function classColor(value: string): string {
  return resolveStatusColor(value).cssClass;
}

export function optionStatusColor(report: IUnifiedBackgroundCheckDateItem): string {
  if (report && report.isactive === false) {
    return '#9e9e9e';
  }
  return resolveStatusColor(report && report.status).optionTextColor;
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/driver-background-check.constants.ts